import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
var INDRAObservatoryService = /** @class */ (function () {
    function INDRAObservatoryService() {
        this.global = [];
    }
    INDRAObservatoryService.prototype.setData = function (data, value) {
        if (!this.global[data]) {
            this.global[data] = new BehaviorSubject(value);
        }
        this.global[data].next(value);
    };
    INDRAObservatoryService.prototype.getData = function (data) {
        if (!this.global[data]) {
            this.setData(data, '');
        }
        return this.global[data].asObservable();
    };
    INDRAObservatoryService.prototype.removeData = function (data) {
        if (_.has(this.global, data)) {
            delete this.global[data];
        }
    };
    INDRAObservatoryService.prototype.checkData = function (data) {
        if (this.global[data]) {
            return true;
        }
        return false;
    };
    INDRAObservatoryService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAObservatoryService_Factory() { return new INDRAObservatoryService(); }, token: INDRAObservatoryService, providedIn: "root" });
    return INDRAObservatoryService;
}());
export { INDRAObservatoryService };
